<style lang="scss">
    .inline-autocomplete {
        .autocomplete {
            padding: 0;
        }
        input {
            border: thin solid #666;
            /*font-size: 1.2em;*/
            border-radius: 3px;
            padding: 8px !important;
            background-color: #fff;
            background-image: none;
            /*padding-left: 50px !important;*/
            &:disabled {
                background-color: #f8f8f8;
                border-color: #e0e0e0;
            }
        }
    }
</style>

<template>
    <form class="uk-width-1-1" autocomplete="off">
        <input autocomplete="false" name="hidden" type="text" style="display:none;">
        <input type="text" name="address" id="address_fake" autocomplete="off" style="display:none">
        <input type="text" name="address" id="address" autocomplete="off" style="display: none;" placeholder="Address" />
        <div class="uk-grid">
            <div class="uk-width-1-1 uk-margin-bottom">
                <label class="uk-text-uppercase">{{ __('global.search_your_address') }}</label>
            </div>

            <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1 ">
                <p class="uk-margin-bottom-remove"><small>&nbsp;{{ __('global.street_address') }}</small></p>
                <autocomplete
                        :placeholder="__('global.street_address')"
                        ref="addressAutocomplete"
                        class="inline-autocomplete"
                        :search="search"
                        :debounce-time="500"
                        :get-result-value="getAddressValue"
                        autocomplete="off"
                        @blur="setAddressLine1"
                        @submit="setAddress"
                >
                    <template
                        #default="{
                        rootProps,
                        inputProps,
                        inputListeners,
                        resultListProps,
                        resultListListeners,
                        results,
                        resultProps
                        }"
                    >
                        <div v-bind="rootProps">
                            <input
                                v-bind="inputProps"
                                v-on="inputListeners"
                                :class="[
                                'autocomplete-input',
                                { 'autocomplete-input-no-results': noResults },
                                { 'autocomplete-input-focused': focused }
                                ]"
                                @focus="handleFocus"
                                @blur="handleBlur"
                                :disabled="isHomeless"
                            />
                            <ul
                                v-if="noResults"
                                class="autocomplete-result-list"
                                style="position: absolute; z-index: 1; width: 100%; top: 100%;"
                            >
                                <li class="autocomplete-result">
                                No results found
                                </li>
                            </ul>
                            <ul v-bind="resultListProps" v-on="resultListListeners">
                                <li
                                    v-for="(result, index) in results"
                                    :key="resultProps[index].id"
                                    v-bind="resultProps[index]"
                                >
                                    {{ result.description }}
                                </li>
                            </ul>
                        </div>
                    </template>
                </autocomplete>

            </div>

            <div class="uk-width-1-1 uk-width-medium-1-2 uk-width-small-1-1">
                <p class="uk-margin-bottom-remove"><small>&nbsp;{{ __('global.street_address_line2') }}</small></p>
                <TextInput
                        v-model="propertyAddress.line_2"
                        :name="__('global.street_address_line2')"
                        :placeholder="__('global.street_address_line2')"
                        :disabled="isHomeless"
                />
            </div>
            <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                <p class="uk-margin-bottom-remove"><small>&nbsp;{{ __('global.property_city') }}</small></p>
                <TextInput
                        v-model="propertyAddress.city"
                        :name="__('global.property_city')"
                        :placeholder="__('global.property_city')"
                        rules="required"
                        @change="$emit('updated', propertyAddress)"
                        :disabled="isHomeless"
                />
            </div>
            <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                <p class="uk-margin-bottom-remove"><small>&nbsp;{{ __('global.property_state') }}</small></p>
                <select @change="$emit('updated', propertyAddress)" v-model="propertyAddress.state_id" class="uk-width-1-1 state-select uk-form-select uk-form-large" :disabled="isHomeless">
                    <option v-for="item in states" :value="item.id" :key="item.id">{{item.state_name}}</option>
                </select>
            </div>
            <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                <p class="uk-margin-bottom-remove"><small>&nbsp;{{ __('global.property_zip') }}</small></p>
                <TextInput

                        v-model="propertyAddress.zip"
                        :name="__('global.property_zip')"
                        :placeholder="__('global.property_zip')"
                        :disabled="isHomeless"
                        rules="required"
                        @change="$emit('updated', propertyAddress)"
                />
            </div>
            <div class="uk-width-1-1 uk-width-medium-1-2 uk-margin-small-top">
                <p class="uk-margin-bottom-remove"><small>&nbsp;{{ __('global.property_county') }}</small></p>
                <validated-section :errors="errors" field="propertyAddress.county_id">
                    <select @change="$emit('updated', propertyAddress)" v-model="propertyAddress.county_id" class="uk-width-1-1 uk-form-select uk-form-large" id="county_field">
                        <option v-for="county in countiesForState" :value="county.id">{{ county.county_name }}</option>
                    </select>
                </validated-section>

            </div>
        </div>
    </form>
</template>

<script>
    import ValidatedSection from "../../Common/ValidatedSection";
    import Autocomplete from '@trevoreyre/autocomplete-vue';
    import {mapState} from "vuex";
    import EventBus from "../../../../dashboard/EventBus";
    export default {
        name: "PrequalAddressForm",
        components: {ValidatedSection, Autocomplete},
        props: ['states', 'counties', 'program', 'isHomeless'],
        data() {
            return {
                defaultPropertyAddress: {
                    line_1: '',
                    line_2: '',
                    city: '',
                    county_id: null,
                    state_id: null,
                    zip: '',
                    latitude: '',
                    longitude: '',
                },
                propertyAddress: {},
                googleAutocomplete: null,
                placesService: null,
            }
        },
        computed: {
            countiesForState() {
                if(!this.propertyAddress.state_id) return [];

                return _.filter(this.counties, county => county.state_id === this.propertyAddress.state_id);
            },
          ...mapState('Prequalification', {
            apiKey: state => state.googleApiKey,
          }),
          ...mapState('App', {
            env: state => state.env,
          }),
        },
        mounted() {
            this.propertyAddress = {
                ...this.defaultPropertyAddress
            }
            this.googleAutocomplete = new google.maps.places.AutocompleteService();
            this.placesService = new google.maps.places.PlacesService(document.createElement('div'));

            EventBus.$on('prequal.setVerifiedAddress', async address => {
                let results = await this.getGoogleResults(address.line_1 + ' ' + address.city + ' ' + address.zip);
                if(results.length) {
                    this.setAddress(results[0]);
                }
            })
            if (this.isHomeless)
            {
                this.loadDefaultProject();
            }
        },
        methods: {
            async loadDefaultProject() {
                this.propertyAddress = {
                    ...this.defaultPropertyAddress                    
                }
                this.$isLoading(true)
                const r = await axios.get(`/api/default-address/${this.program.id}`);
                if (r.data.success)
                {
                    this.propertyAddress = r.data.data
                    this.$refs.addressAutocomplete.value = this.propertyAddress.line_1
                }
                this.$isLoading(false)
                this.$emit('updated', this.propertyAddress);
            },

            setAddressLine1($event) {
                this.propertyAddress.line_1 = $event.target.value;
            },
            async search(term) {
                if(term.length < 2) return [];
                let r = await this.getGoogleResults(term);
                return r;
            },
            getGoogleResults(term) {
                return new Promise((resolve, reject) => {
                    this.googleAutocomplete.getPlacePredictions({
                        input: term,
                        types: ['address'],
                    }, resolve)
                })
            },
            getAddressValue(result) {
                return result.description;
            },
            setAddress(result) {
                // Get Place Details

                this.placesService.getDetails({ placeId: result.place_id}, place => {

                    let numberComponent = this.getPlaceComponentByType(place, 'street_number');
                    let streetComponent = this.getPlaceComponentByType(place, 'route');
                    let cityComponent = this.getPlaceComponentByType(place, 'locality');
                    if(!cityComponent) {
                        cityComponent = this.getPlaceComponentByType(place, 'administrative_area_level_3');
                    }
                    let countyNameComponent = this.getPlaceComponentByType(place, "administrative_area_level_2");
                    let stateAbbrComponent = this.getPlaceComponentByType(place, 'administrative_area_level_1');
                    let zipComponent = this.getPlaceComponentByType(place, 'postal_code');


                    let number = numberComponent ? numberComponent.long_name : '';
                    let street = streetComponent ? streetComponent.short_name : '';
                    let city = cityComponent ? cityComponent.long_name : '';
                    let countyName = countyNameComponent ? countyNameComponent.long_name : '';
                    let stateAbbr = stateAbbrComponent ? stateAbbrComponent.short_name : '';
                    let zip = zipComponent ? zipComponent.short_name : '';

                    this.$refs.addressAutocomplete.value = number + ' ' + street;
                    this.propertyAddress.line_1 = number + ' ' + street;
                    this.propertyAddress.city = city;
                    this.propertyAddress.zip = zip;
                    this.propertyAddress.latitude =  place.geometry.location.lat();
                    this.propertyAddress.longitude =  place.geometry.location.lng();
                    this.propertyAddress.state_id = this.getStateIdFromAbbr(stateAbbr);
                    this.propertyAddress.county_id = this.getCountyIdFromName(countyName);
                    this.$emit('updated', this.propertyAddress);

                    //lock the county field when inputting address
                    //document.getElementById('county_field').setAttribute('disabled', 'disabled');
                })
            },
            getStateIdFromAbbr(stateAbbr) {
                for(var i in this.states) {
                    if(this.states[i].state_acronym === stateAbbr) {
                        return this.states[i].id;
                    }
                }
            },

            getCountyIdFromName(countyName) {
                for(var i in this.countiesForState) {
                    let county = this.countiesForState[i];
                    if(county.county_name === countyName) {
                        return county.id;
                    }
                    let shortName = countyName.replace(' County', '');
                    if(county.county_name === shortName) {
                        return county.id;
                    }
                }
            },
            getPlaceComponentByType(place, type) {
                for(var i in place.address_components) {
                    for(var j in place.address_components[i].types) {
                        if(place.address_components[i].types[j] === type) {
                            return place.address_components[i];
                        }
                    }
                }
            },
        }
    }
</script>
